import { ResendSms } from './ResendSms/ResendSms';

export const ResendSmsPage = () => {
  return <ResendSms />;
};
